// extracted by mini-css-extract-plugin
export default {"tabs-container":"product-list-tabs__tabs-container___3vy2G","treadwell-icon":"product-list-tabs__treadwell-icon___2_TxG"};